/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymAppointmentsStepCheckupCalendarAliases {
  DATE_PICKER_CHECKUP_SCHEDULE_RANGE = 'date-picker-checkup-schedule-range',
  LAYOUT_CHECKUP_SCHEDULE_PERIOD = 'layout-checkup-schedule-period',
  PANEL_CHECKUP_SCHEDULE_PERIOD = 'panel-checkup-schedule-period',
}
export { PseudonymAppointmentsStepCheckupCalendarAliases };
